import { render, staticRenderFns } from "./ReplacementContract.html?vue&type=template&id=2f409ffb&external"
import script from "./ReplacementContract.ts?vue&type=script&lang=ts&external"
export * from "./ReplacementContract.ts?vue&type=script&lang=ts&external"
import style0 from "./ReplacementContract.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports